export default{
    originConstants: {
        internal: 'Internal',
    },
};


// WEBPACK FOOTER //
// ./settings/originConstants.ts